// ─────────────────────────────────────────────────────────────────
// Firebase initialization
// ─────────────────────────────────────────────────────────────────
// API keys for Firebase web apps are NOT secrets — they're designed
// to ship in client code. Security depends on:
//   1. Authorized domains (Auth → Settings)
//   2. Storage rules (Storage → Rules)
//   3. Firestore rules (Firestore → Rules)
//
// Console flips required before deploy, in project `ai-stax`:
//   ✓ Auth → Sign-in method → Google → ENABLE
//   ✓ Auth → Settings → Authorized domains → add hosting domain
//   ✓ Storage → Get started + paste storage.rules
//   ✓ Firestore → Create database (production mode) + paste firestore.rules
// ─────────────────────────────────────────────────────────────────

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            'AIzaSyBpRE1J5bRBp5MtjgFv_YZz9VCwBt4QHuQ',
  authDomain:        'ai-stax.firebaseapp.com',
  projectId:         'ai-stax',
  storageBucket:     'ai-stax.firebasestorage.app',
  messagingSenderId: '749203706435',
  appId:             '1:749203706435:web:d6b657acdb917e7ef0baf6',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
export const firebaseStorage = getStorage(firebaseApp);
export const firestoreDb = getFirestore(firebaseApp);

// Prompt account selection on every sign-in so users can switch accounts.
googleProvider.setCustomParameters({ prompt: 'select_account' });
